import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IPays } from '@core';
import { CustomValidators } from '@core-lib/classes';

@Directive({
    selector: '[swift]',
    standalone: false
})
export class SwiftDirective {
	@Input('swiftForm') swiftForm: AbstractControl;
	@Input('checkOnChangePays') checkOnChangePays: boolean = false;

	@Input()
	set pays(value: IPays) {
		this._pays = value;
		if (value && this.checkOnChangePays) {
			this.validateSwiftFormat(value);
		}
	}
	private _pays: IPays;
	get pays(): IPays {
		return this._pays;
	}

	inputElement: HTMLInputElement;

	constructor(private el: ElementRef) {
		this.inputElement = el.nativeElement;
	}

	@HostListener('blur', ['$event']) onBlur($event): void {
		const value: string = this.inputElement.value;
		if (!value) {
			return;
		}
		//valider format SWIFT suivant le paramétrage dans le pays
		if (this.swiftForm && this.pays) {
			this.validateSwiftFormat(this.pays);
		}
	}

	@HostListener('keydown', ['$event']) onKeydown($event): void {
		if ($event.key == 'Enter') {
			const value: string = this.inputElement.value;
			if (!value) {
				return;
			}
			if (this.swiftForm && this.pays) {
				this.validateSwiftFormat(this.pays);
			}
		}
	}

	@HostListener('focus', ['$event']) onFocus($event) {
		$event.target.value = this.inputElement.value?.replace(/\s/g, '');
	}

	validateSwiftFormat(pays: IPays) {
		this.swiftForm.setValidators([
			CustomValidators.respectFormatISO(4, 5, pays.codeISO, pays.paysParent?.codeISO, 'swift'),
			CustomValidators.wrongSwiftBicLength(),
			CustomValidators.notEmpty()
		]);

		this.swiftForm.updateValueAndValidity({ emitEvent: false });
	}
}
